<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import browserUtils from './util/browserUtils'

export default {
  name: 'App',
  mounted () {
    /* ie下部分路由不跳转修复 */
    if (browserUtils.isIE()) {
      window.addEventListener('hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.replace(currentPath)
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import "styles/index";

  #app {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue